export default "__VITE_ASSET__BZsmMnHX__"